export default __webpack_public_path__ + "static/210602_夏日活動強更預告_jp-b554a35b991aadace1096a9ca43951af.png";